<template>
  <div class="list-page">
    <SimpleTable
      ref="regionalQuota"
      table-code="regionalQuota"
      :menus="['查询', '批量修改', '插入', '批量删除']"
      :rightFrozenColCount="1"
      :columns="columns"
      :data="tableData"
      :loading="loading"
      @modify-data-change="onModifyDataChange"
    />

    <Details ref="details" @close="getTableData" />
  </div>
</template>

<script>
import { sortRecords, addCbFn, getOptions } from '@/utils/index'
import SimpleTable from '@/components/SimpleTable/index.vue'
import Details from './Details.vue'

export default {
  name: 'RegionalQuota',
  components: {
    SimpleTable,
    Details
  },
  data() {
    return {
      columns: [
        {
          field: 'name',
          title: '区域定额名称',
          canEdit: true,
          canModify: true
        },
        {
          field: 'regionName',
          title: '所在地区',
          ...getOptions(
            {
              title: '对应估算',
              key: 'name',
              options: async () => {
                const res = await this.$service.get('/region/list', {})
                return sortRecords(res?.data || [])
              },
              confirm: (selectedCellInfos, res) => {
                const row = res[0][0].originData
                selectedCellInfos.forEach(cells => {
                  const obj = cells[0].originData
                  this.$set(obj, 'regionName', row.name)
                  this.$set(obj, 'regionId', row.id)
                })
              }
            },
            false
          ),
          canModify: true
        },
        {
          field: 'sysCreatedDate',
          title: '更新日期',
          editor: { type: 'date' }
        },
        {
          field: 'operation',
          title: '操作',
          width: 40,
          cellType: 'text',
          buttons: [
            {
              action: 'import',
              text: '更新数据',
              click: (row, record) => {
                this.import(row, record)
              }
            }
          ]
        }
      ],
      tableData: [],
      loading: false
    }
  },
  created() {
    this.getTableData()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    async getTableData() {
      this.loading = true
      const res = await this.$service.get('/quota-library/list')
      this.loading = false
      this.tableData = sortRecords(res?.data || [])
    },

    import(row) {
      if (!this.tableData[row]?.id) {
        this.$message.warning('请先保存该数据')
        return
      }
      this.$refs.details.show(this.tableData[row])
    },

    async onModifyDataChange(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        '/quota-library/batch',
        getModifyData,
        cleanModifyData
      )

      this.getTableData()
    }
  }
}
</script>

<style scoped>
.list-page {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>
